import { Button, Text, VStack } from '@chakra-ui/react';

import TabButtonsList from './TabButtonsList';

import { HEADER_BREAKPOINT } from 'constants/global';

export const TabInfo = ({
  title,
  text,
  btnText = null,
  btnLink = null,
  tabButtonsListData = undefined,
  ...props
}) => (
  <VStack
    pos={{ [HEADER_BREAKPOINT]: 'sticky' }}
    top="0"
    align="start"
    minW={{ [HEADER_BREAKPOINT]: '336px' }}
    maxW={{ mobile: '600px', [HEADER_BREAKPOINT]: '336px' }}
    gap="unset"
    {...props}
  >
    <Text
      as="h3"
      textStyle="header.h4"
      fontSize={{ mobile: '18px', [HEADER_BREAKPOINT]: '24px', xds: '32px' }}
      pb={{ mobile: '12px', desktop: '16px' }}
    >
      {title}
    </Text>

    <Text textStyle="h2" fontSize={{ mobile: '12px', [HEADER_BREAKPOINT]: '16px' }}>
      {text}
    </Text>

    {btnText && <Button size="secondary">{btnText}</Button>}

    {tabButtonsListData && <TabButtonsList buttons={tabButtonsListData} />}
  </VStack>
);
